<template>
  <v-app>
    <Sidebar v-if="authenticated && !isPublicRoute && !isMustChangePassword" v-model="drawer"/>
    <!-- Botón hamburguesa: solo se monta en móvil para no afectar el layout en desktop -->
    <v-app-bar
      v-if="authenticated && !isPublicRoute && !isMustChangePassword && isMobile"
      app
      color="white"
      elevation="1"
    >
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-toolbar-title class="text-subtitle-1 font-weight-bold">Evaluaciones</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
      <v-dialog v-model="sessionModal.open" max-width="460">
        <v-card>
          <v-card-title class="text-h6">{{ sessionModal.title }}</v-card-title>
          <v-card-text>{{ sessionModal.message }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="ackSessionModal">Entendido</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import { connectWebSocket, disconnectWebSocket } from '@/services/wsClient.js';

export default {
  name: 'App',
  components: {
    Sidebar: () => import(/* webpackChunkName: "about" */ '@/components/ui/Sidebar.vue'),
  },
  data() {
    return {
      drawer: null, // null = Vuetify decide según el breakpoint
      sessionModal: {
        open: false,
        title: 'Sesión cerrada',
        message: 'Tu sesión ha sido cerrada o se perdió la conexión.',
      },
      wsModalTimer: null,
    };
  },
  computed: {
    authenticated() {
      return this.$store.getters['Auth/authenticated'];
    },
    isPublicRoute() {
      return this.$route.path === '/login' || this.$route.meta?.public === true;
    },
    isMustChangePassword() {
      return this.$route.name === 'changePassword';
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    '$store.state.idleVue.isIdle'(newVal) {
      if (newVal) this.logout();
    },
  },
  created() {
    const token = sessionStorage.token;
    if (token) {
      try {
        connectWebSocket(token, null, null, this.$store, this.$router);
      } catch (e) { /* noop */ }
    }
    window.addEventListener('session-kicked', this.onSessionKicked);
    window.addEventListener('ws-disconnected', this.onWsDisconnected);
  },
  beforeDestroy() {
    disconnectWebSocket();
    window.socketActivo = false;
    if (this.wsModalTimer) {
      clearTimeout(this.wsModalTimer);
      this.wsModalTimer = null;
    }
    window.removeEventListener('session-kicked', this.onSessionKicked);
    window.removeEventListener('ws-disconnected', this.onWsDisconnected);
  },
  methods: {
    async logout() {
      await this.$store.dispatch('Auth/logout');
      disconnectWebSocket();
      window.socketActivo = false;
      if (this.$route.path !== '/login') this.$router.push('/login');
    },
    onSessionKicked(e) {
      const reason = e?.detail?.reason || 'Tu sesión ha sido cerrada.';
      this.sessionModal = { open: true, title: 'Sesión finalizada', message: reason };
    },
    onWsDisconnected(e) {
      const { reason } = e?.detail || {};
      if (this.wsModalTimer) {
        clearTimeout(this.wsModalTimer);
        this.wsModalTimer = null;
      }
      this.wsModalTimer = setTimeout(() => {
        const stillDown = typeof window !== 'undefined' ? window.socketActivo === false : true;
        if (!this.isPublicRoute && stillDown) {
          this.sessionModal = {
            open: true,
            title: 'Conexión perdida',
            message: reason || 'Se ha perdido la conexión con el servidor.',
          };
        }
        this.wsModalTimer = null;
      }, 4500);
    },
    ackSessionModal() {
      this.sessionModal.open = false;
      if (!this.isPublicRoute) {
        this.$router.push({ path: '/login', query: { reason: 'ws_down' } }).catch(() => {});
      }
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito&display=swap');
*, body, p, a, h1, h2, h3 {
  font-family: 'Nunito', sans-serif;
}
</style>
